<script setup lang="ts">
import { useQuasar } from 'quasar';
import SchoolResetPasswordView from 'src/modules/School/views/SchoolResetPasswordView/SchoolResetPasswordView.vue';
import FlashAuthPageDecoration from 'src/shared/components/FlashAuthPageDecoration/FlashAuthPageDecoration.vue';

const $q = useQuasar();
$q.dark.set(false);
</script>

<template>
  <q-page
    padding
    class="column bg-primary"
  >
    <SchoolResetPasswordView
      class="column fit items-center justify-center relative"
    />
    <FlashAuthPageDecoration v-if="!$q.platform.is.mobile" />
  </q-page>
</template>
